import React from "react"
import PropTypes from "prop-types"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { useForm, Controller, set } from "react-hook-form"
import { createRate, getServiceProvidersBusiness } from "../../services/api"

import { useEffect, useState } from "react"
import { makeStyles } from "@mui/styles"
import { useApp } from "../../../../AppProvider"
import { Typography } from "@mui/material"
import LoadingDialog from "../../../../components/LoadingDialog/LoadingDialog"
import SecundaryButton from "../../../../components/SecundaryButton/SecundaryButton"
import PrimaryButton from "../../../../components/PrimaryButton/PrimaryButton"

const helperTextStyles = makeStyles((theme) => ({
  root: {
    margin: 4,
    color: "black",
  },
  error: {
    "&.MuiFormHelperText-root.Mui-error": {
      padding: 0,
      margin: 0,
    },
  },
}))

const classUseStyles = makeStyles(() => ({
  baseActionButton: {
    fontSize: "14px !important",
    minWidth: "100px !important",
    fontWeight: "600 !important",
    backgroundColor: "#FFFFFF !important",
    border: "#3DB76E 1px solid !important",
    borderRadius: "8px !important",
    color: "#3DB76E !important",
    textTransform: "none !important",
    "@media screen and (maxWidth: 400px)": {
      fontSize: "0.4rem",
    },
    fontFamily: "Ubuntu !important",
  },
  nextActionButton: {
    backgroundColor: "#3DB76E !important",
    color: "white !important",
  },
}))

const ViewRateModal = ({
  open,
  setOpen,
  rateId,
  rateBusiness,
  rateMovilnet,
  rateMovistar,
  rateDigitel,
  rateVigency,
  rateMinimumBilling,
  update,
  callback,
}) => {
  const [errorMovilnetText, setErrorMovilnetText] = useState("")
  const [errorMovistarText, setErrorMovistarText] = useState("")
  const [errorDigitelText, setErrorDigitelText] = useState("")
  const [errorMinimumBillingText, setErrorMinimumBillingText] = useState("")
  const [errorVigencyText, setErrorVigencyText] = useState("")

  const [disabledMovilnet, setDisabledMovilnet] = useState(true)
  const [disabledMovistar, setDisabledMovistar] = useState(true)
  const [disabledDigitel, setDisabledDigitel] = useState(true)

  const [loadingUpdateRate, setLoadingUpdateRate] = useState(false)

  const { showNotification } = useApp()

  const formClasses = classUseStyles()
  const { control, handleSubmit, reset, setValue, clearErrors } = useForm({
    defaultValues: {
      movistar: "0",
      movilnet: "0",
      digitel: "0",
      vigency: "",
      minimumBilling: "0",
    },
  })

  const setRatesData = (
    movistar,
    movilnet,
    digitel,
    vigency,
    minimumBilling
  ) => {
    if (movistar === 0) {
      setValue("movistar", "0")
    } else {
      setValue(
        "movistar",
        movistar.toLocaleString("de-DE", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })
      )
    }

    if (movilnet === 0) {
      setValue("movilnet", "0")
    } else {
      setValue(
        "movilnet",
        movilnet.toLocaleString("de-DE", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })
      )
    }
    if (digitel === 0) {
      setValue("digitel", "0")
    } else {
      setValue(
        "digitel",
        digitel.toLocaleString("de-DE", {
          minimumFractionDigits: 3,
          maximumFractionDigits: 3,
        })
      )
    }
    setValue("vigency", vigency)
    if (minimumBilling === 0) {
      setValue("minimumBilling", "0")
    } else {
      setValue(
        "minimumBilling",
        minimumBilling.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      )
    }
  }

  const useStylesOption = makeStyles({
    option: {
      "&:hover": {
        backgroundColor: "#DAE6F1 !important",
        color: "#0957A0",
        font: "Ubuntu",
        size: "16px",
      },
    },
  })

  const useStyles = makeStyles(() => ({
    longitudIcon: {
      "& svg": {
        width: "24px",
        height: "22px",
      },
    },
  }))

  const textInput = React.useRef(null)

  const onSubmit = async (data) => {
    try {
      var algunerror = ""
      data.movistar = data.movistar.replace(",", ".")
      data.digitel = data.digitel.replace(",", ".")
      data.movilnet = data.movilnet.replace(",", ".")
      data.minimumBilling = data.minimumBilling.replace(",", ".")

      if (isNaN(parseFloat(data.movistar))) {
        setErrorMovistarText("Debe ser un número")
        algunerror = "e"
      }

      if (isNaN(parseFloat(data.digitel))) {
        setErrorDigitelText("Debe ser un número")
        algunerror = "e"
      }

      if (isNaN(parseFloat(data.movilnet))) {
        setErrorMovilnetText("Debe ser un número")
        algunerror = "e"
      }

      if (isNaN(parseFloat(data.minimumBilling))) {
        setErrorMinimumBillingText("Debe ser un número")
        algunerror = "e"
      }

      if (
        (!data.movistar || parseFloat(data.movistar) <= 0) &&
        !disabledMovistar
      ) {
        setErrorMovistarText("Debe ser mayor a 0")
        algunerror = "e"
      }

      if (
        (!data.digitel || parseFloat(data.digitel) <= 0) &&
        !disabledDigitel
      ) {
        setErrorDigitelText("Debe ser mayor a 0")
        algunerror = "e"
      }

      if (
        (!data.movilnet || parseFloat(data.movilnet) <= 0) &&
        !disabledMovilnet
      ) {
        setErrorMovilnetText("Debe ser mayor a 0")
        algunerror = "e"
      }
      if (
        data.minimumBilling === undefined ||
        parseFloat(data.minimumBilling) < 0
      ) {
        setErrorMinimumBillingText("Debe ser positiva")
        algunerror = "e"
      }

      if (!data.vigency) {
        setErrorVigencyText("Debe haber una fecha de vigencia")
        algunerror = "e"
      }

      if (algunerror === "") {
        if (update) {
          setLoadingUpdateRate(true)
          await createRate(
            parseFloat(data.movistar),
            parseFloat(data.digitel),
            parseFloat(data.movilnet),
            data.vigency,
            parseFloat(data.minimumBilling),
            [{ id: rateBusiness.id }]
          )
          callback()
          setLoadingUpdateRate(false)
          handleClose()
          showNotification("Tarifa actualizada exitosamente", "success")
        }
      }
    } catch (error) {
      setLoadingUpdateRate(false)
      if (error.response === undefined) {
        showNotification(
          "Lo sentimos se ha producido un error inesperado al editar la tarifa",
          "error"
        )
      } else {
        showNotification(error.response.data.message, "error")
      }
    }
  }

  const handleClose = () => {
    reset()
    setErrorMovilnetText("")
    setErrorMovistarText("")
    setErrorDigitelText("")
    setErrorMinimumBillingText("")
    setErrorVigencyText("")
    setDisabledMovilnet(true)
    setDisabledMovistar(true)
    setDisabledDigitel(true)
    setOpen(false)
    callback()
  }

  const DialogActionspadding = {
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
  }

  const modalestilo = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    width: "530px !important",
    maxWidth: "530px !important",
    borderRadius: "8px",
    height: "fit-content",
    padding: "0px 0px 10px 0px",
  }

  const textotitulomodal = {
    fontFamily: "Ubuntu",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#363636",
    marginTop: "8px",
    marginLeft: "-10px",
    marginBottom: "6px",
    textAlign: "center",
  }

  const formaestilo = {
    borderTop: "1px solid #979797",
  }

  const dialogoestilo = {
    margin: "0em 1.8em 0 1.8em",
    height: "fit-content",
  }

  const handleFocusMovilnet = (event) => {
    event.preventDefault()
    const { target } = event
    setErrorMovilnetText("")
  }

  const handleFocusMovistar = (event) => {
    event.preventDefault()
    const { target } = event
    setErrorMovistarText("")
  }

  const handleFocusDigitel = (event) => {
    event.preventDefault()
    const { target } = event
    setErrorDigitelText("")
  }

  const handleFocusMinimumBilling = (event) => {
    event.preventDefault()
    const { target } = event
    setErrorMinimumBillingText("")
  }

  useEffect(() => {
    const checkServiceProviders = async () => {
      if (!open) return
      if (!rateBusiness) return
      const serviceProviders = await getServiceProvidersBusiness(
        rateBusiness.id
      )
      let newMovistarRate = 0
      let newMovilnetRate = 0
      let newDigitelRate = 0
      serviceProviders.data.forEach((serviceProvider) => {
        if (serviceProvider.nombre.toLowerCase() == "movistar") {
          setDisabledMovistar(false)
          newMovistarRate = rateMovistar
        }
        if (serviceProvider.nombre.toLowerCase() == "movilnet") {
          setDisabledMovilnet(false)
          newMovilnetRate = rateMovilnet
        }
        if (serviceProvider.nombre.toLowerCase() == "digitel") {
          setDisabledDigitel(false)
          newDigitelRate = rateDigitel
        }
      })
      setRatesData(
        newMovistarRate,
        newMovilnetRate,
        newDigitelRate,
        rateVigency,
        rateMinimumBilling
      )
    }
    checkServiceProviders()
  }, [open])

  let tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const helperTestClasses = helperTextStyles()

  const handleInputChange = (event) => {
    let { name, value } = event.target
    value = value.replace(".", ",")
    setValue(name, value)
  }
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: modalestilo,
      }}
    >
      <DialogTitle>
        <div>
          <h2 style={textotitulomodal}>
            {update ? "Actualizar tarifa" : "Ver Detalle"}
          </h2>
        </div>
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} id="datos" style={formaestilo}>
        <DialogContent style={dialogoestilo}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "15px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
                marginTop: "0",
                paddingTop: "0",
                marginLeft: "6.5px",
                marginBottom: "20px",
              }}
            >
              Empresa:{" "}
              {rateBusiness == undefined ? "" : rateBusiness.razonSocial}
            </Typography>
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "800",
                fontSize: "17px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
                marginTop: "0",
                paddingTop: "0",
                marginLeft: "6.5px",
                marginBottom: "20px",
              }}
            >
              Operadoras
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "450",
                fontSize: "15px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              Digitel 412 / 422
            </Typography>
            <Controller
              name="digitel"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  id="digitel"
                  inputRef={textInput}
                  disabled={!update || disabledDigitel}
                  onFocus={handleFocusDigitel}
                  inputProps={{ maxLength: 5 }}
                  sx={{
                    "& .MuiInputBase-root.Mui-disabled": {
                      ...(!disabledDigitel && {
                        "& > fieldset": {
                          borderColor: "#1BC3DD",
                        },
                      }),
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      ...(!disabledDigitel && {
                        WebkitTextFillColor: "#000000",
                      }),
                    },
                    "& .MuiOutlinedInput-root ": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      fieldset: {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                    },
                    color: "rgba(0, 0, 0, 0.87) !important",
                    height: "40px",
                    width: "40%",
                    textAlignLast: "center",
                  }}
                  FormHelperTextProps={{ classes: helperTestClasses }}
                  type="text"
                  fullWidth
                  variant="outlined"
                  size="small"
                  error={errorDigitelText !== ""}
                  helperText={errorDigitelText}
                  {...field}
                  onChange={handleInputChange}
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "450",
                fontSize: "15px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              Movistar 414 / 424
            </Typography>
            <Controller
              name="movistar"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  id="movistar"
                  inputProps={{ maxLength: 5 }}
                  inputRef={textInput}
                  disabled={!update || disabledMovistar}
                  onFocus={handleFocusMovistar}
                  sx={{
                    "& .MuiInputBase-root.Mui-disabled": {
                      ...(!disabledMovistar && {
                        "& > fieldset": {
                          borderColor: "#1BC3DD",
                        },
                      }),
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      ...(!disabledMovistar && {
                        WebkitTextFillColor: "#000000",
                      }),
                    },
                    "& .MuiOutlinedInput-root ": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      fieldset: {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                    },
                    color: "rgba(0, 0, 0, 0.87) !important",
                    height: "40px",
                    width: "40%",
                    textAlignLast: "center",
                  }}
                  type="text"
                  fullWidth
                  variant="outlined"
                  FormHelperTextProps={{ classes: helperTestClasses }}
                  size="small"
                  error={errorMovistarText !== ""}
                  helperText={errorMovistarText}
                  {...field}
                  onChange={handleInputChange}
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "25px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "450",
                fontSize: "15px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              Movilnet 416 / 426
            </Typography>
            <Controller
              name="movilnet"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  id="movilnet"
                  inputProps={{ maxLength: 5 }}
                  inputRef={textInput}
                  disabled={!update || disabledMovilnet}
                  onFocus={handleFocusMovilnet}
                  sx={{
                    "& .MuiInputBase-root.Mui-disabled": {
                      ...(!disabledMovilnet && {
                        "& > fieldset": {
                          borderColor: "#1BC3DD",
                        },
                      }),
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      ...(!disabledMovilnet && {
                        WebkitTextFillColor: "#000000",
                      }),
                    },
                    "& .MuiOutlinedInput-root ": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      fieldset: {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                    },
                    color: "rgba(0, 0, 0, 0.87) !important",
                    height: "40px",
                    width: "40%",
                    textAlignLast: "center",
                  }}
                  type="text"
                  fullWidth
                  FormHelperTextProps={{ classes: helperTestClasses }}
                  variant="outlined"
                  size="small"
                  error={errorMovilnetText !== ""}
                  helperText={errorMovilnetText}
                  {...field}
                  onChange={handleInputChange}
                />
              )}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Controller
              name="vigency"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  id="vigency"
                  inputRef={textInput}
                  disabled={!update}
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "#000000",
                    },
                    "& .MuiOutlinedInput-root ": {
                      "&.Mui-focused fieldset": {
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      fieldset: {
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      height: "50px",
                    },
                    "& label": {
                      color: "black",
                      fontFamily: "Ubuntu",
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: "16px",
                    },
                    height: "58px",
                    width: "100%",
                    marginTop: 0.0,
                  }}
                  label="Válido a partir de:"
                  type="date"
                  inputProps={{
                    min: tomorrow.toISOString().split("T")[0],
                  }}
                  onInvalid={(e) => {
                    e.target.setCustomValidity(
                      "La fecha debe ser mayor a la de hoy."
                    )
                  }}
                  onFocus={(e) => {
                    if (new Date(e.target.value) >= new Date()) {
                      e.target.setCustomValidity("")
                    }
                  }}
                  onKeyDown={(e) => {
                    if (new Date(e.target.value) >= new Date()) {
                      e.target.setCustomValidity("")
                    }
                  }}
                  onKeyUp={(e) => {
                    if (new Date(e.target.value) >= new Date()) {
                      e.target.setCustomValidity("")
                    }
                  }}
                  FormHelperTextProps={{ classes: helperTestClasses }}
                  variant="outlined"
                  error={errorVigencyText !== ""}
                  helperText={errorVigencyText}
                  {...field}
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "450",
                fontSize: "15px",
                letterSpacing: "0.15px",
                color: "rgba(0, 0, 0, 0.87)",
              }}
            >
              Facturación Mínima en USD
            </Typography>

            <Controller
              name="minimumBilling"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  margin="dense"
                  id="minimumBilling"
                  inputRef={textInput}
                  disabled={!update}
                  onFocus={handleFocusMinimumBilling}
                  sx={{
                    "& .MuiInputBase-root.Mui-disabled": {
                      "& > fieldset": {
                        borderColor: "#1BC3DD",
                      },
                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "#000000",
                    },
                    "& .MuiOutlinedInput-root ": {
                      "&.Mui-focused fieldset": {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                      fieldset: {
                        borderColor: "#1BC3DD",
                        borderRadius: "10px",
                        borderWidth: "2px",
                      },
                    },
                    color: "rgba(0, 0, 0, 0.87) !important",
                    height: "40px",
                    width: "40%",
                    textAlignLast: "center",
                  }}
                  type="text"
                  FormHelperTextProps={{ classes: helperTestClasses }}
                  variant="outlined"
                  size="small"
                  error={errorMinimumBillingText !== ""}
                  helperText={errorMinimumBillingText}
                  {...field}
                  onChange={handleInputChange}
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              gap: "5px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                letterSpacing: "0.15px",
                color: "#737373",
                marginTop: "0",
                paddingTop: "0",
              }}
            >
              Los montos se encuentran expresados en dólares americanos.
            </Typography>
            <Typography
              variant="h6"
              style={{
                fontFamily: "Ubuntu",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                color: "#737373",
                marginTop: "0",
                paddingTop: "0",
              }}
            >
              Las tarifas no incluyen impuestos, son pagaderas a tasa del B.C.V.
            </Typography>
          </div>
        </DialogContent>

        <DialogActions style={DialogActionspadding}>
          {update && (
            <React.Fragment>
              <SecundaryButton
                text="Cancelar"
                action={handleClose}
                fontSize="14"
                width="125px"
                height="40px"
                lineHeight="28"
                type="button"
                noShadow={true}
              />
              <PrimaryButton
                text="Guardar"
                action={() => {}}
                fontSize="14"
                width="125px"
                height="40px"
                lineHeight="28"
                type="submit"
                noShadow={true}
              />
            </React.Fragment>
          )}
          {!update && (
            <React.Fragment>
              <SecundaryButton
                text="Cancelar"
                action={handleClose}
                fontSize="14"
                width="125px"
                height="40px"
                lineHeight="28"
                type="button"
                noShadow={true}
              />
            </React.Fragment>
          )}
        </DialogActions>
      </form>
      <LoadingDialog shouldOpen={loadingUpdateRate} />
    </Dialog>
  )
}

ViewRateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  rateId: PropTypes.number,
  rateBusiness: PropTypes.object,
  rateMovilnet: PropTypes.number,
  rateMovistar: PropTypes.number,
  rateDigitel: PropTypes.number,
  rateVigency: PropTypes.string,
  rateMinimumBilling: PropTypes.number,
  update: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
}

export default ViewRateModal
